import React from "react";
import { useSelector } from "react-redux";
import { View, Text, StyleSheet } from "react-native";
import { globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";

const TradingFeeSellCDA = ({ isLimit, configKey = "" }) => {
  const globalConfigData = useSelector(
    (state) => state.utilReducer.globalConfigData
  );
  const tfSell = globalConfigData?.[configKey];

  return (
    <>
      {tfSell && tfSell?.feeMain ? (
        <View style={{ marginTop: 5 }}>
          <Text style={styles.textStyle}>{tfSell?.feeMain}</Text>
          {!tfSell?.feeAddnl ? (
            <Text style={styles.textStyle}>
              {isLimit ? tfSell?.feeAddnlLimit : tfSell?.feeAddnlMarket}
            </Text>
          ) : (
            <Text style={styles.textStyle}>{tfSell?.feeAddnl}</Text>
          )}
        </View>
      ) : null}
    </>
  );
};

export default TradingFeeSellCDA;

const styles = StyleSheet.create({
  textStyle: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.black2,
    textAlign: "center",
  },
});
